import { OrganizationsState, CatOrganization, OrgAppId, OrgClientId, OrgUser } from "./organizations"

export default {
  setLoading(state: OrganizationsState, loading: boolean) {
    state.loading = loading
  },
  setLoadingAppIds(state: OrganizationsState, loading: boolean) {
    state.loadingAppIds = loading
  },
  setLoadingClientIds(state: OrganizationsState, loading: boolean) {
    state.loadingClientIds = loading
  },
  setLoadingUsers(state: OrganizationsState, loading: boolean) {
    state.loadingUsers = loading
  },
  setOrganizations(state: OrganizationsState, organizations: CatOrganization[]) {
    state.organizations = organizations
  },
  addOrganization(state: OrganizationsState, org: CatOrganization) {
    state.organizations = [org, ...state.organizations]
  },
  updateOrganization(state: OrganizationsState, updated: CatOrganization) {
    const index = state.organizations.findIndex(o => o.id === updated.id)
    if (index !== -1) {
      state.organizations.splice(index, 1, updated)
    }
  },
  removeOrganization(state: OrganizationsState, id: string) {
    state.organizations = state.organizations.filter(o => o.id !== id)
  },
  setSelectedOrganization(state: OrganizationsState, org: CatOrganization | null) {
    state.selectedOrganization = org
  },
  setOrgAppIds(state: OrganizationsState, appIds: OrgAppId[]) {
    state.orgAppIds = appIds
  },
  setOrgClientIds(state: OrganizationsState, clientIds: OrgClientId[]) {
    state.orgClientIds = clientIds
  },
  setOrgUsers(state: OrganizationsState, users: OrgUser[]) {
    state.orgUsers = users
  },
}
